import React from 'react'
import { Label } from 'core/screen-util'
const style = { display: 'grid', justifyContent: 'center', color: 'white' }
const DailyEventTypeDescription = _ => {
  return (
    <div
      style={{
        display: 'grid',
        gridTemplateColumns: '50% 50%',
        gap: '2%',
        // gridTemplateRows: '50px',
        // width: width + 'px',
        // height: height + 'px',
        height: '100%',
        width: '100%',
        overflowY: 'auto',
        overflowX: 'hidden',
        border: '1px solid black',
        padding: '1px',
      }}
    >
      <div style={{ backgroundColor: '#07e92b', ...style }}>Avaliable</div>
      <div style={{ backgroundColor: reserveColor, ...style }}>Reserve</div>
      <div style={{ backgroundColor: 'red', ...style }}>Unplanned</div>
      <div style={{ backgroundColor: planned, ...style }}>Planned</div>
      <div style={{ backgroundColor: 'blue', ...style }}>Maintenance</div>
      <div style={{ backgroundColor: extension, ...style }}>Extension</div>

      {/* <Label>Avaliable</Label>
      <div style={{ backgroundColor: '#07e92b' }} />
      <Label>Reserve</Label>
      <div style={{ backgroundColor: reserveColor }} />
      <Label>Unplanned</Label>
      <div style={{ backgroundColor: 'red' }} />
      <Label>Planned</Label>
      <div style={{ backgroundColor: planned }} />
      <Label>Maintenance</Label>
      <div style={{ backgroundColor: 'blue' }} />
      <Label>Extension</Label>
      <div style={{ backgroundColor: extension }} /> */}
      <Label>Forced Part.</Label>
      <SvgPattern id="redpattern">
        <Pattern id="redpattern" rgb="red" />
      </SvgPattern>
      <Label>Maint. Part.</Label>
      <SvgPattern id="bluepattern">
        <Pattern id="bluepattern" rgb="blue" />
      </SvgPattern>
      <Label>Planned Part.</Label>
      <SvgPattern id="planedpattern">
        <Pattern id="planedpattern" rgb="rgb(0,233,233)" />
      </SvgPattern>
      <Label>Derated Ext.</Label>
      <SvgPattern id="deratepattern">
        <Pattern id="deratepattern" rgb="rgb(255, 128, 0)" />
      </SvgPattern>
    </div>
  )
}

export default DailyEventTypeDescription

export const reserveColor = 'rgb(192,192,192)'
export const planned = 'rgb(0,233,233)'
export const extension = 'rgb(255,128,0)'

export const SvgPattern = ({ children, id }) => (
  <svg height={20}>
    {children}
    <rect
      height={20}
      width={100}
      x={0}
      y={0}
      style={{
        fill: `url(#${id})`,
        stroke: 'red',
        strokeWidth: 0,
        fillOpacity: 0.7,
        strokeOpacity: 0.9,
        width: '100vw',
      }}
    />
  </svg>
)

export const Pattern = ({ id, rgb }) => (
  <pattern
    id={id}
    width="8"
    height="5"
    patternUnits="userSpaceOnUse"
    patternTransform="rotate(0 50 50)"
  >
    <line stroke={rgb} strokeWidth="5px" y2="10" />
  </pattern>
)
